import DefaultIcon from './DefaultIcon';

export default DefaultIcon;
